/**
 * scroll-animations.js
 * Applies alternating .fade-left / .fade-right classes to product grid items
 * and uses IntersectionObserver to add .show when each card enters the viewport.
 *
 * CSS for .fade-left, .fade-right, .show lives in component-apple-polish.css.
 */
(function () {
  'use strict';

  /* Skip if user prefers reduced motion or browser lacks IntersectionObserver */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  function init() {
    /* Target .grid__item elements inside Shopify product grids.
       Excludes .sig-products which handles its own animation via data-sig-card. */
    var items = document.querySelectorAll(
      '.product-grid .grid__item, ' +
      '.collection-product-list .grid__item'
    );

    if (!items.length) return;

    items.forEach(function (item, index) {
      /* Avoid double-initialising (e.g. after section re-render in editor) */
      if (item.dataset.saInit) return;
      item.dataset.saInit = '1';

      /* Alternate left / right by index */
      item.classList.add(index % 2 === 0 ? 'fade-left' : 'fade-right');
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        var el = entry.target;

        /* Stagger by the item's visual column position (up to 4 cols) */
        var siblings = Array.from(el.parentNode.children);
        var col = siblings.indexOf(el) % 4;
        el.style.transitionDelay = (col * 0.09) + 's';

        el.classList.add('show');
        io.unobserve(el);
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -48px 0px'
    });

    document.querySelectorAll('.fade-left, .fade-right').forEach(function (el) {
      io.observe(el);
    });
  }

  /* Run after DOM is ready */
  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
